import useConfigInject from '../_util/hooks/useConfigInject';
import * as Svg from './svg';
const LIGHT_EMPTY_SCENE_MAP = {
    default: Svg.DefaultLightImage,
    permi: Svg.NotPermiLightImage,
    network: Svg.NotNetworkLightImage,
    found: Svg.NotFoundLightImage,
    account: Svg.NotAccountLightImage,
    message: Svg.NotMessageLightImage,
    system: Svg.SystemLightImage,
    search: Svg.SearchLightImage,
};
const DARK_EMPTY_SCENE_MAP = {
    default: Svg.DefaultDarkImage,
    permi: Svg.NotPermiDarkImage,
    network: Svg.NotNetworkDarkImage,
    found: Svg.NotFoundDarkImage,
    account: Svg.NotAccountDarkImage,
    message: Svg.NotMessageDarkImage,
    system: Svg.SystemDarkImage,
    search: Svg.SearchDarkImage,
};
const getEmpty = (props = {}) => {
    const { getPrefixCls } = useConfigInject('empty', {});
    const { scene, mode } = props;
    const prefixCls = getPrefixCls(`empty-img-${scene}`);
    const getDefaultImage = () => {
        return mode === 'dark' ? Svg.DefaultDarkImage(prefixCls) : Svg.DefaultLightImage(prefixCls);
    };
    const content = prefixCls => {
        const MAP = mode === 'dark' ? DARK_EMPTY_SCENE_MAP : LIGHT_EMPTY_SCENE_MAP;
        const getImage = MAP[scene] || getDefaultImage;
        return getImage(prefixCls);
    };
    return content(prefixCls);
};
export default getEmpty;
